import store from 'src/store/index';

export default class OrgSettingsHelper {
    isSubModuleExist (moduleType, submoduleType) {
        const modules = store.getters['userprofile/getOrganizationSettings'];
        let module = {};
        for (var i = 0; i < modules.length; i++) {
            if (modules[i].name === moduleType) {
                module = modules[i];
                break;
            }
        }
        if ((Object.keys(module).length > 0 && module.settings.enabled === true) &&
            (submoduleType in module.settings && module.settings[submoduleType].enabled === true)) {
            return true;
        }

        return false;
    }
};
